// extracted by mini-css-extract-plugin
export default {"component":"BackToTop_component__C12M9","isLocked":"BackToTop_isLocked__nZqAZ","isVisible":"BackToTop_isVisible__7zFnY","icon":"BackToTop_icon__-XgGv"};